import React from "react";

//package import

import { Navigate, useLocation } from "react-router-dom";
import { decodeToken, isExpired } from "react-jwt";

//user import

import { RoutesUrls } from "./index";
import { StorageKeys } from "../../Storage/index";
import { USER_ROLES_ENUM } from "../../../common/Enums";

//constants

//component

export const PrivateRoute = ({ element: Component, ...rest }) => {
	//hooks

	const auth = useAuth();

	//return component

	return auth ? <Component {...rest} /> : <Navigate to={RoutesUrls?.root} />;
};

export const PrivateRouteWrapper = ({ children }) => {
	//hooks

	const auth = useAuth();

	//return component

	return auth ? children : <Navigate to={RoutesUrls?.root} />;
};

//auth hook

export const useAuth = () => {
	const token = localStorage.getItem(StorageKeys?.token);
	const { pathname } = useLocation();

	const validToken = validatedDecodedToken(token);

	if (validToken?.role) {
		if (verifyRole(validToken?.role, pathname)) {
			return true;
		}
	}

	localStorage.clear();
	return false;
};

const verifyRole = (role, pathname) => {
	switch (role) {
		case USER_ROLES_ENUM.superAdmin:
			return pathname.includes(RoutesUrls?.admin) ? true : false;
		case USER_ROLES_ENUM.state:
			return pathname.includes(RoutesUrls?.provinceAdmin) ? true : false;
		case USER_ROLES_ENUM.ministry:
			return pathname.includes(RoutesUrls?.ministryAdmin) ? true : false;
		case USER_ROLES_ENUM.district:
			return pathname.includes(RoutesUrls?.districtAdmin) ? true : false;
		case USER_ROLES_ENUM.hospital:
			return pathname.includes(RoutesUrls?.pouAdmin) ? true : false;

		default:
			return false;
	}
};

export const getDecodedToken = (t) => {
	const token = t ? t : localStorage.getItem(StorageKeys?.token);

	const validToken = validatedDecodedToken(token);
	if (validToken) {
		return validToken;
	}

	localStorage.clear();
	return false;
};

export const useDecodedToken = () => {
	return getDecodedToken();
};

export const resetToken = (t) => {
	if (validatedDecodedToken(t)) {
		localStorage.setItem(StorageKeys?.token, t);
		return true;
	}
	return false;
};

const validatedDecodedToken = (token) => {
	if (token) {
		//checking token is expired or not
		const expired = isExpired(token);

		if (!expired) {
			//decoding token is expired or not
			const decodedToken = decodeToken(token);
			if (decodedToken) {
				return decodedToken;
			}
		}
	}
	return false;
};

export default PrivateRoute;
